import {IDayNotesState, initialDayNotesState} from '@app/core/store/state/daynotes.state';
import {ErrorActions} from '@app/core/store/actions/error.actions';
import {DayNotesActions, EDayNotesActions} from '@app/core/store/actions/daynotes.actions';

export const dayNotesReducers = (
	state = initialDayNotesState,
	action: DayNotesActions | ErrorActions,
): IDayNotesState => {
	switch (action.type) {
		case EDayNotesActions.SetSelectedDayNote: {
			return {
				...state,
				selectedDayNote: action.dayNote
			};
		}
		case EDayNotesActions.DeleteDayNoteSuccess: {
			return {
				...state,
				dayNotes: state.dayNotes.filter(d => d.id !== action.dayNoteId)
			};
		}
		case EDayNotesActions.PostDayNoteSuccess: {
			return {
				...state,
				dayNotes: [action.dayNote].concat(state.dayNotes)
			};
		}
		case EDayNotesActions.GetDayNotes: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDayNotesActions.GetDayNotesSuccess: {
			return {
				...state,
				isLoading: false,
				dayNotes: action.dayNotes.sort((a, b) => b.updated_at.toDate().valueOf() - a.updated_at.toDate().valueOf())
			};
		}
		case EDayNotesActions.PatchDayNoteSuccess: {
			return {
				...state,
				dayNotes: state.dayNotes.map(d => {
					if (d.id === action.dayNote.id) {
						return action.dayNote;
					}
					return d;
				})
			};
		}
		case EDayNotesActions.SetSelectedDate: {
			return {
				...state,
				selectedDate: action.selectedDate
			};
		}
		default:
			return state;
	}
};
